import { checkPassword, PasswordPolicy } from '../utils/passwordPolicy'

/**
 * The organization's password rules under a password field, each ticked as the password meets
 * it. Shown before anything is typed, so nobody learns the rules from a refusal.
 */
export default function PasswordRules({ password, policy, className = '' }: {
  password: string
  policy: PasswordPolicy
  className?: string
}) {
  const checks = checkPassword(password, policy)
  return (
    <ul className={`mt-2 space-y-0.5 text-xs ${className}`} aria-label="Password requirements">
      {checks.map(({ rule, met }) => (
        <li
          key={rule}
          data-met={met ? 'true' : 'false'}
          className={`flex items-center gap-1.5 ${
            met ? 'text-emerald-500' : 'text-theme-text-tertiary'
          }`}
        >
          <span aria-hidden="true" className="inline-block w-3 text-center">{met ? '✓' : '•'}</span>
          <span>{rule}</span>
        </li>
      ))}
    </ul>
  )
}
